import React, { useRef } from 'react';
import { Select } from "../../../Catalyst/select";
import { TopicCategory, Topic } from "../../../../services/NotesService";

interface SelectedTopic {
  id: number;
  name: string;
}

interface TopicsDropdownProps {
  topics: TopicCategory[];
  topicsStatus: string;
  selectedItems: SelectedTopic[];
  isDropdownOpen: boolean;
  onToggleDropdown: () => void;
  onCheckboxChange: (topic: Topic) => void;
}


const TopicsDropdown: React.FC<TopicsDropdownProps> = ({
  topics,
  topicsStatus,
  selectedItems,
  isDropdownOpen,
  onToggleDropdown,
  onCheckboxChange
}) => {
  const dropdownContentRef = useRef<HTMLDivElement>(null);

  const getDropdownDisplayText = () => {
    return 'Topics';
  };

  // Custom handler to focus dropdown content after opening
  const handleSelectClick = (e: React.MouseEvent<HTMLSelectElement>) => {
    onToggleDropdown();
    setTimeout(() => {
      dropdownContentRef.current?.focus();
    }, 0);
  };

  return (
    <div className="relative topic-dropdown-container">
      <Select
        value=""
        onChange={() => { }} // Controlled by custom dropdown
        onClick={handleSelectClick}
        className="w-48 cursor-pointer"
      >
        <option value="" >
          {getDropdownDisplayText()}
        </option>
      </Select>

      {/* Custom Dropdown - positioned above */}
      {isDropdownOpen && (
        <div className="absolute bottom-full left-0 mb-1 w-64 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
          <div
            ref={dropdownContentRef}
            tabIndex={-1}
            className="p-4 max-h-64 overflow-y-auto focus:outline-none"
          >
            {topicsStatus === 'loading' ? (
              <div className="text-center text-gray-500">Loading topics...</div>
            ) : (
              topics?.map((category: TopicCategory) => (
                <div key={category.id} className="mb-4 last:mb-0">
                  <h4 className="font-medium text-gray-500 mb-2 text-xs">
                    {category.name}
                  </h4>
                  <div className="space-y-2">
                    {category.topics.map((topic: Topic) => (
                      <label
                        key={topic.id}
                        className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-1 rounded"
                      >
                        {/* Hidden native checkbox */}
                        <input
                          type="checkbox"
                          checked={selectedItems.some(item => item.id === topic.id)}
                          onChange={() => onCheckboxChange(topic)}
                          className="peer hidden"
                        />

                        {/* Custom checkbox */}
                        <span
                          className="
      flex-shrink-0
      w-4 h-4
      rounded
      border border-gray-400
      flex items-center justify-center
      peer-checked:bg-gray-900
      peer-checked:border-gray-900
    "
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
                            <path d="M8.69471 0.292787C8.88218 0.480314 8.9875 0.734622 8.9875 0.999786C8.9875 1.26495 8.88218 1.51926 8.69471 1.70679L3.69471 6.70679C3.50718 6.89426 3.25288 6.99957 2.98771 6.99957C2.72255 6.99957 2.46824 6.89426 2.28071 6.70679L0.280712 4.70679C0.0985537 4.51818 -0.00224062 4.26558 3.78026e-05 4.00339C0.00231622 3.74119 0.107485 3.49038 0.292893 3.30497C0.478301 3.11956 0.729114 3.01439 0.99131 3.01211C1.25351 3.00983 1.50611 3.11063 1.69471 3.29279L2.98771 4.58579L7.28071 0.292787C7.46824 0.105316 7.72255 0 7.98771 0C8.25288 0 8.50718 0.105316 8.69471 0.292787Z" fill="white" />
                          </svg>
                        </span>

                        <span className="text-sm text-primary-900">{topic.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TopicsDropdown;
